export default {
  'password': '請輸入密碼',
  'passwordError': '密碼為8-20位，僅支持大小寫字母、數字和符號三種及以上的組合',
  'passwordAgain': '請再次輸入密碼',
  'passwordNotSame': '兩次輸入密碼不一致',
  'requiredVerifyCode': '請輸入驗證碼',
  'verifyCode': '驗證碼錯誤'
}
